export default __webpack_public_path__ + "static/media/blur-background.e1155027.png";